import { render, staticRenderFns } from "./payments-account-payables.vue?vue&type=template&id=1957ad1e"
import script from "./payments-account-payables.vue?vue&type=script&lang=js"
export * from "./payments-account-payables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports